/**
 * Handles core Header interactions (Sticky Header).
 */
export const initHeader = (): void => {
  initStickyHeader();
};

const initStickyHeader = () => {
  const header = document.querySelector<HTMLElement>(".site-header");
  if (!header) return;

  const threshold = 100;
  let isSticky = false;

  window.addEventListener(
    "scroll",
    () => {
      const shouldBeSticky = window.scrollY > threshold;
      if (shouldBeSticky !== isSticky) {
        isSticky = shouldBeSticky;
        header.classList.toggle("is-sticky", isSticky);
      }
    },
    { passive: true },
  );
};
